import * as E from "react";
import { createContext as S, useContext as C, useCallback as v, useMemo as p, useState as g, useEffect as m, useRef as N } from "react";
import { jsx as T } from "react/jsx-runtime";
import { isBrowser as Q } from "@one-snap/toolbox";
function we(e) {
  return {
    textColorClass: `snap-color-${e}`,
    backgroundColorClass: `snap-background-color-${e}`
  };
}
function ve(e) {
  if (!e || e.length < 2)
    return "";
  const t = e.replace(/\s+/g, " ").split(" ");
  return t.length > 1 ? `${t[0].charAt(0)}${t[1].charAt(0)}` : `${e.slice(0, 2)}`.toUpperCase();
}
/*! js-cookie v3.0.1 | MIT */
function R(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var s in n)
      e[s] = n[s];
  }
  return e;
}
var X = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function B(e, t) {
  function n(o, c, r) {
    if (!(typeof document > "u")) {
      r = R({}, t, r), typeof r.expires == "number" && (r.expires = new Date(Date.now() + r.expires * 864e5)), r.expires && (r.expires = r.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var a in r)
        r[a] && (i += "; " + a, r[a] !== !0 && (i += "=" + r[a].split(";")[0]));
      return document.cookie = o + "=" + e.write(c, o) + i;
    }
  }
  function s(o) {
    if (!(typeof document > "u" || arguments.length && !o)) {
      for (var c = document.cookie ? document.cookie.split("; ") : [], r = {}, i = 0; i < c.length; i++) {
        var a = c[i].split("="), d = a.slice(1).join("=");
        try {
          var u = decodeURIComponent(a[0]);
          if (r[u] = e.read(d, u), o === u)
            break;
        } catch {
        }
      }
      return o ? r[o] : r;
    }
  }
  return Object.create(
    {
      set: n,
      get: s,
      remove: function(o, c) {
        n(
          o,
          "",
          R({}, c, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return B(this.converter, R({}, this.attributes, o));
      },
      withConverter: function(o) {
        return B(R({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var W = B(X, { path: "/" });
function _(e, t, n, s) {
  const o = /* @__PURE__ */ new Date(), c = s ? V() : window.location.hostname;
  if (n) {
    const i = o.getMilliseconds();
    o.setMilliseconds(i + n);
  }
  const r = {
    expires: n ? o : null,
    domain: c
  };
  W.set(
    e,
    typeof t == "object" ? JSON.stringify(t) : t,
    r
  );
}
function H(e) {
  return W.get(e);
}
function me(e, t) {
  const n = t ? V() : window.location.hostname;
  W.remove(e, { domain: n });
}
function V() {
  return window.location.hostname === "localhost" ? "localhost" : "snapfinance.com";
}
const y = "userId", M = "sessionId";
function Y() {
  let e = "", t, n;
  for (t = 0; t < 32; t++)
    n = Math.random() * 16 | 0, (t === 8 || t === 12 || t === 16 || t === 20) && (e += "-"), e += (t === 12 ? 4 : t === 16 ? n & 3 | 8 : n).toString(
      16
    );
  return e;
}
const J = 6307e7;
function Z() {
  if (typeof window > "u")
    return "";
  const e = H(y), t = localStorage.getItem(y), n = e || t || Y();
  return _(y, n, J, !0), localStorage.setItem(y, n), n;
}
function F() {
  if (typeof window > "u")
    return "";
  const t = sessionStorage.getItem(M) || Y();
  return _(M, t, J, !0), sessionStorage.setItem(M, t), t;
}
const O = S({
  logFetchError: (e, t, n, s, o) => console.error(
    "ErrorTrackingContext not implemented at the app level, also error tracking vendor needs to be integrated",
    {
      method: e,
      path: t,
      httpStatus: n,
      severity: s,
      response: o
    }
  )
});
function ee() {
  const { logFetchError: e } = C(O);
  return {
    fetchWithErrorTracking: v(
      async (n, {
        handleErrorTrackingSeverity: s,
        ...o
      } = {}) => {
        var r;
        const c = (o == null ? void 0 : o.method) || "GET";
        try {
          const i = await fetch(n, o);
          if (!i.ok) {
            const a = (s == null ? void 0 : s(i.status)) || "error";
            e(c, n, i.status, a, i);
          }
          return i;
        } catch (i) {
          e(c, n, ((r = i == null ? void 0 : i.response) == null ? void 0 : r.status) || 0, "error", i);
        }
      },
      []
    )
  };
}
const q = S({}), xe = (e) => /* @__PURE__ */ T(q.Provider, { value: e.values, children: e.children }), Ie = () => ({
  pageSEO: C(q)
});
function Ce(e) {
  return function() {
    const { execute: n, executing: s } = e(), o = v(
      async (c) => {
        var i, a;
        const r = await n(c);
        return {
          ...r,
          success: !((i = r == null ? void 0 : r.errors) != null && i.length),
          hasErrors: ((a = r == null ? void 0 : r.errors) == null ? void 0 : a.length) > 0
        };
      },
      [n]
    );
    return p(
      () => ({ execute: o, executing: s }),
      [o, s]
    );
  };
}
function Ee(e, t) {
  const [n, s] = g(e);
  return m(
    () => {
      const o = setTimeout(() => {
        s(e);
      }, t);
      return () => {
        clearTimeout(o);
      };
    },
    [e, t]
    // Only re-call effect if value or delay changes
  ), n;
}
const G = S({}), te = () => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  return {
    /* sets cache value to "waiting" while waiting for cache to populate */
    setStatus: (n, s) => e.set(n, s),
    /* to check if cache is waiting */
    getStatus: (n) => e.get(n),
    /* sets value in cache and emit any subscription */
    set: (n, s) => {
      e.set(n, s), t.has(n) && t.get(n).forEach((o) => o()), t.delete(n);
    },
    /* call this function only if getStatus returns something  */
    /* gets value if available otherwise waits for cache to emit, */
    get: (n) => e.get(n) === "waiting" ? new Promise((s) => {
      t.has(n) || t.set(n, []), t.get(n).push(() => s(e.get(n)));
    }) : e.get(n)
  };
}, Se = ({ children: e }) => {
  const t = p(te, []);
  return /* @__PURE__ */ T(G.Provider, { value: { cache: t }, children: e });
};
function ne(e, t) {
  const { cache: n } = C(G), [s, o] = g(!1), [c, r] = g(null), [i, a] = g(null), d = N(null);
  d.current = e;
  const u = v(async () => {
    o(!1);
    const h = await (n == null ? void 0 : n.get(
      t.cacheKey
    ));
    return a(h.data), h.success || r(h), h;
  }, [n, t == null ? void 0 : t.cacheKey]), l = v(
    async (...h) => {
      o(!0), r(null);
      let f, w;
      if (t != null && t.cacheKey && (n != null && n.getStatus(t.cacheKey)))
        return await u();
      t != null && t.cacheKey && (n == null || n.setStatus(t == null ? void 0 : t.cacheKey, "waiting"));
      try {
        f = await d.current(...h), w = (t == null ? void 0 : t.responseAs) === "text" ? await f.text() : await f.json(), a(w), f.ok || r(A(f, w));
      } catch (b) {
        r(b);
      }
      return o(!1), t != null && t.cacheKey && (n == null || n.set(
        t.cacheKey,
        A(f, w)
      )), A(f, w);
    },
    [d]
  );
  return {
    loading: s,
    error: c,
    data: i,
    call: l
  };
}
function pe(e, t) {
  const { fetchWithErrorTracking: n } = ee(), { loading: s, error: o, data: c, call: r } = ne(
    () => n(e),
    t
  );
  return m(() => {
    r();
  }, [r]), {
    loading: s,
    error: o,
    data: c
  };
}
function A(e, t) {
  var o;
  const n = {};
  (o = e == null ? void 0 : e.headers) == null || o.forEach((c, r) => n[r] = c);
  const s = {
    status: e == null ? void 0 : e.status,
    success: (e == null ? void 0 : e.status) === 200,
    headers: n
  };
  return s.data = t, s;
}
const re = S({});
function be() {
  return { config: C(re) };
}
function Re() {
  const [e, t] = g(null), n = N(null), s = v(
    (r) => {
      var i;
      window.sessionStorage.setItem(
        "fingerprint",
        JSON.stringify(r)
      ), (i = n.current) == null || i.call(n, r), t(r);
    },
    [n]
  ), o = v(() => {
    const r = window.sessionStorage.getItem("fingerprint");
    return r ? JSON.parse(r) : null;
  }, []);
  m(() => {
    const r = o();
    if (r) {
      s(r);
      return;
    }
    (async () => {
      const a = await import("./index-BhywPjsy.mjs"), { clientJS: d } = a, u = {
        fingerprintId: d.getFingerprint(),
        isMobile: d.isMobile(),
        browser: d.getBrowser(),
        clientIP: "0.0.0.0"
        // default ip
      };
      s(u);
      try {
        const l = await window.fetch(
          "https://api.ipify.org?format=json&callback=getIP",
          {
            signal: AbortSignal.timeout(2e3)
            // timeout after this time
          }
        );
        if (!l.ok)
          throw l;
        const h = await l.json();
        u.clientIP = h.ip;
      } catch (l) {
        console.error(l);
      }
      s(u);
    })();
  }, [s, o]);
  const c = v(
    () => new Promise((r) => {
      const i = o();
      if (i)
        return r(i);
      n.current = (a) => {
        n.current = null, r(a);
      };
    }),
    [n, o]
  );
  return { fingerprint: e, getFingerprint: c };
}
function ye() {
  m(() => {
    const e = document.createElement("script"), t = (n) => {
      n.type === "load" ? window.fcWidget.init({
        token: "7449e058-8c00-4a0d-ab90-54856e2cd80a",
        host: "https://wchat.freshchat.com"
      }) : console.log("Error loading freshchat");
    };
    e.type = "text/javascript", e.src = "https://wchat.freshchat.com/js/widget.js", e.id = "freshChat", document.body.appendChild(e), e.addEventListener("load", t), e.addEventListener("error", t);
  }, []);
}
var j = /* @__PURE__ */ new Map(), P = /* @__PURE__ */ new WeakMap(), $ = 0, oe = void 0;
function se(e) {
  return e ? (P.has(e) || ($ += 1, P.set(e, $.toString())), P.get(e)) : "0";
}
function ie(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? se(e.root) : e[t]}`).toString();
}
function ce(e) {
  let t = ie(e), n = j.get(t);
  if (!n) {
    const s = /* @__PURE__ */ new Map();
    let o;
    const c = new IntersectionObserver((r) => {
      r.forEach((i) => {
        var a;
        const d = i.isIntersecting && o.some((u) => i.intersectionRatio >= u);
        e.trackVisibility && typeof i.isVisible > "u" && (i.isVisible = d), (a = s.get(i.target)) == null || a.forEach((u) => {
          u(d, i);
        });
      });
    }, e);
    o = c.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: c,
      elements: s
    }, j.set(t, n);
  }
  return n;
}
function ae(e, t, n = {}, s = oe) {
  if (typeof window.IntersectionObserver > "u" && s !== void 0) {
    const a = e.getBoundingClientRect();
    return t(s, {
      isIntersecting: s,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: a,
      intersectionRect: a,
      rootBounds: a
    }), () => {
    };
  }
  const { id: o, observer: c, elements: r } = ce(n);
  let i = r.get(e) || [];
  return r.has(e) || r.set(e, i), i.push(t), c.observe(e), function() {
    i.splice(i.indexOf(t), 1), i.length === 0 && (r.delete(e), c.unobserve(e)), r.size === 0 && (c.disconnect(), j.delete(o));
  };
}
function ue({
  threshold: e,
  delay: t,
  trackVisibility: n,
  rootMargin: s,
  root: o,
  triggerOnce: c,
  skip: r,
  initialInView: i,
  fallbackInView: a,
  onChange: d
} = {}) {
  var u;
  const [l, h] = E.useState(null), f = E.useRef(), [w, b] = E.useState({
    inView: !!i,
    entry: void 0
  });
  f.current = d, E.useEffect(
    () => {
      if (r || !l)
        return;
      let I;
      return I = ae(
        l,
        (L, D) => {
          b({
            inView: L,
            entry: D
          }), f.current && f.current(L, D), D.isIntersecting && c && I && (I(), I = void 0);
        },
        {
          root: o,
          rootMargin: s,
          threshold: e,
          // @ts-ignore
          trackVisibility: n,
          // @ts-ignore
          delay: t
        },
        a
      ), () => {
        I && I();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(e) ? e.toString() : e,
      l,
      o,
      s,
      c,
      r,
      n,
      a,
      t
    ]
  );
  const U = (u = w.entry) == null ? void 0 : u.target, K = E.useRef();
  !l && U && !c && !r && K.current !== U && (K.current = U, b({
    inView: !!i,
    entry: void 0
  }));
  const x = [h, w.inView, w.entry];
  return x.ref = x[0], x.inView = x[1], x.entry = x[2], x;
}
const Pe = (e, t) => {
  const [n] = ue({
    triggerOnce: !0,
    onChange: async (s) => {
      s && e && await t();
    }
  });
  return { lastEntity: n };
}, Ue = (e = { distance: 25, enabled: !0 }) => {
  const [t, n] = g(!1), s = e.distance || 5, o = typeof e.enabled == "boolean" ? e.enabled : !0;
  return m(() => {
    const c = () => window.scrollY > s ? n(!0) : n(!1);
    return o && window.addEventListener("scroll", c), () => {
      window.removeEventListener("scroll", c);
    };
  }, [o, s]), { scrolled: t };
};
function De() {
  return {
    sessionId: p(() => F(), [])
  };
}
function Me() {
  return {
    userId: p(() => Z(), [])
  };
}
function de() {
  const [e, t] = g(0), [n, s] = g(0), o = () => {
    t(window.innerWidth), s(window.innerHeight);
  };
  return m(() => (o(), window.addEventListener("resize", o), () => window.removeEventListener("resize", o)), []), {
    width: e,
    height: n
  };
}
function Ae() {
  const e = v((n) => {
    window.location.href = n;
  }, []), t = v((n) => {
    window.location.replace(n);
  }, []);
  return { navigate: e, replace: t };
}
const Be = (e) => {
  const t = C(e);
  if (t == null)
    throw new Error(
      `You should wrap component in ${e.displayName ?? "Context Provider"}`
    );
  return t;
};
function je() {
  const e = N(null), [t, n] = g(0), [s, o] = g(!1), { width: c } = de();
  return m(() => {
    var i;
    const r = (i = e == null ? void 0 : e.current) == null ? void 0 : i.offsetHeight;
    n(r), o(!1);
  }, [s, c]), { height: t, setIsReady: o, ref: e };
}
const k = S([!1, () => {
}]), Ne = ({ children: e }) => {
  const [t, n] = g(!1);
  return /* @__PURE__ */ T(
    k.Provider,
    {
      value: [t, n],
      children: e
    }
  );
}, Te = () => {
  const [e, t] = C(k);
  return { modernNavBarEnabled: e, setModernNavBarEnabled: t };
};
function We(e, t = [], n = 0) {
  m(() => {
    const s = setTimeout(() => {
      e();
    }, n);
    return () => clearTimeout(s);
  }, [...t, n, e]);
}
const _e = () => p(() => {
  if (!Q || !navigator.cookieEnabled)
    return;
  const t = H(z);
  if (t)
    return t;
  {
    const n = le();
    return _(z, n, 31536e6, !0), n;
  }
}, []), z = "analytics_uuid", le = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
  const t = Math.random() * 16 | 0;
  return (e === "x" ? t : t & 3 | 8).toString(16);
});
export {
  O as ErrorTrackingContext,
  re as FetchAPIConfigContext,
  G as FetchContext,
  Se as FetchProvider,
  Ne as ModernNavBarProvider,
  xe as PageSEOProvider,
  q as PageSEOProviderContext,
  J as TWO_YEARS,
  A as buildFetchResponse,
  te as createCache,
  Ce as createCommandHook,
  we as getColor,
  H as getCookie,
  ve as getInitialsFromName,
  F as getSessionId,
  Z as getUserId,
  me as removeCookie,
  _ as storeCookie,
  _e as useAnalyticsUUID,
  Ae as useBrowserNavigation,
  je as useCalculateRefHeight,
  ne as useCall,
  Ee as useDebounce,
  We as useEffectDeferred,
  be as useFetchAPIConfigContext,
  ee as useFetchWithErrorTracking,
  Re as useFingerprint,
  ye as useFreshChat,
  pe as useGet,
  Pe as useInfiniteScroll,
  Te as useModernNavBarContext,
  Ie as usePageSEOProviderContext,
  Be as useRequiredContext,
  Ue as useScrolledDown,
  De as useSessionId,
  Me as useUserId,
  de as useWindowResize
};
